<template>
  <div :style="createStyle" aria-busy="true" class="sb-loading__placeholder" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
export type SbLoadingPlaceholderProps = {
  width?: string
  height?: string
  borderRadius?: string
  marginBottom?: string
}

const props = defineProps<SbLoadingPlaceholderProps>()

const createStyle = computed(() => ({
  width: props.width ?? '50%',
  height: props.height ?? '25px',
  borderRadius: props.borderRadius ?? '8px',
  marginBottom: props.marginBottom ?? '10px',
}))
</script>
